<template>
  <div>
    <div class="content-box">
      <div class="os-tabs-w">
        <div class="os-tabs-controls os-tabs-complex text-right">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <span aria-expanded="true" class="nav-link active"
                ><small style="color: blue" class="tab-value">RECIBIDO EN:</small
                ><span style="font-size: 18px" class="tab-label">{{
                  current_recepcion.tienda_obj.nombre
                }}</span></span
              >
            </li>
            <li class="nav-item">
              <span aria-expanded="true" class="nav-link active"
                ><small style="color: blue" class="tab-value">RECEPCION:</small
                ><span style="font-size: 18px" class="tab-label"
                  >#{{ current_recepcion.numero }}</span
                ></span
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'compras-factura' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Atras
              </router-link>
              <h5 class="form-header">
                Factura #
                <u>{{ current.documento }}</u>
                &nbsp;
                <div
                  class="badge"
                  :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'B',
                    'badge-danger': current.estado == '9',
                    'badge-dark': current.estado == 'C',
                  }"
                >
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">{{ current.estado_str }}</span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>
                &nbsp;
                <div
                  class="badge"
                  :class="{
                    'badge-success': current.fecha_revision,
                    'badge-danger': !current.fecha_revision,
                  }"
                >
                  <span v-if="current.fecha_revision && current.estado != 9"
                    ><i class="fa fa-check"></i> Revisada</span
                  >
                  <span v-if="!current.fecha_revision"
                    ><i class="fas fa-times"></i> No revisada</span
                  >
                </div>
                <div class="st-meta float-right">
                  <button @click="abrirModalLogRecepciones()" class="btn btn-info">
                    Log de modificaciones <i class="fas fa-history"></i>
                  </button>
                  &nbsp;
                  <div class="btn-group">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                    >
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        v-if="!current.fecha_revision"
                        @click="RevisarFactura()"
                        class="dropdown-item"
                        href="#"
                        type="button"
                      >
                        <i class="fa fa-check-double"></i>
                        Marcar como revisada
                      </button>
                      <router-link
                        :to="{
                          name: 'inventario-entrada_compra-editar',
                          params: { id: current.entrada_por_compra_e },
                        }"
                      >
                        <button class="dropdown-item" href="#" type="button">
                          <i class="fa fa-share"></i>
                          Ir a entrada por compra
                        </button>
                      </router-link>
                      <router-link
                        :to="{
                          name: 'wms-recepcion-editar',
                          params: { id: current.recepcion },
                        }"
                      >
                        <button class="dropdown-item" href="#" type="button">
                          <i class="fa fa-share"></i>
                          Ir a recepción de mercancía
                        </button>
                      </router-link>
                      <button
                        @click="generarCXP()"
                        class="dropdown-item"
                        href="#"
                        type="button"
                      >
                        <i class="fa fa-cash-register"></i>
                        Generar cargo CXP
                      </button>
                      <button
                        @click="abrirModalCorregirProveedor()"
                        class="dropdown-item"
                        href="#"
                        type="button"
                      >
                        <i class="fas fa-edit"></i>
                        Modificar datos de la recepción
                      </button>
                      <button
                        @click="abrirModalModificarFactura()"
                        class="dropdown-item"
                        href="#"
                        type="button"
                      >
                        <i class="fas fa-edit"></i>
                        Modificar datos de factura
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        @click="imprimir(current)"
                      >
                        <i class="fas fa-print"></i>
                        Imprimir Diferencia de Precio Factura
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        @click="mostrarArchivoAdjunto()"
                      >
                        <i class="fa fa-share"></i>
                        Ver documento adjunto
                      </button>
                    </div>
                  </div>
                </div>
              </h5>
              <div class="row">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for>Serie</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-model="current.serie"
                        class="form-control"
                        placeholder="Caja"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for>Proveedor</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-if="current.proveedor && current.proveedor.nombre"
                        v-model="current.proveedor.nombre"
                        class="form-control"
                        placeholder="Caja"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for>Usuario</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-if="current.usuario && current.usuario.username"
                        v-model="current.usuario.username"
                        class="form-control"
                        placeholder="Caja"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for>Fecha de factura</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-if="current.usuario && current.usuario.username"
                        v-model="current.fecha_documento"
                        class="form-control"
                        placeholder="Caja"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Total Documento</label>
                    <div class="input-group">
                      <input
                        disabled
                        v-if="current.usuario && current.usuario.username"
                        v-model="current.total_documento"
                        class="form-control"
                        placeholder="Caja"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="invoice-table">
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th class="text-right" style="width: 9%">OC</th>
                        <th class="text-right" style="width: 6%">Ingresada</th>
                        <th class="text-right" style="width: 6%">Mal estado</th>
                        <th class="text-right" style="width: 6%">Cantidad</th>
                        <th class="text-right" style="width: 9%">Precio undad</th>
                        <th class="text-right" style="width: 9%">Diferencia de Precio</th>
                        <th class="text-right" style="width: 9%">Total precio</th>
                        <th class="text-center" style="width: 24%">Tipo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="detalle in current.facturad_set"
                        v-bind:key="detalle.id"
                        @click="verDetalleLinea(detalle)"
                        v-bind:class="{
                          'table-danger':
                            detalle.estado == 'N' || detalle.cantidad_mal_estado > 0,
                        }"
                      >
                        <td>
                          {{ detalle.producto_obj.sku }} -
                          {{ detalle.producto_obj.nombre }}
                        </td>
                        <td class="text-right font-weight-bold" style="color: #241dfb">
                          <span v-if="detalle.orden_compra_d">{{
                            detalle.orden_compra_d.cantidad
                          }}</span>
                        </td>
                        <td
                          class="text-right font-weight-bold"
                          v-bind:style="
                            detalle.estado == 'N' ? 'color: #e91414;' : 'color: #37c21b;'
                          "
                        >
                          <span v-if="detalle.cantidad">
                            <span v-if="detalle.estado == 'N'">-</span>
                            <span v-else>+</span> {{ detalle.cantidad }}</span
                          >
                        </td>
                        <td class="text-right font-weight-bold" style="color: #e91414">
                          <span v-if="detalle.cantidad_mal_estado"
                            >- {{ detalle.cantidad_mal_estado }}</span
                          >
                        </td>
                        <td class="text-right font-weight-bold" style="color: #00000">
                          <span>{{ detalle.cantidad_total }}</span>
                        </td>
                        <td
                          v-if="detalle.precio_unidad_real"
                          class="text-right font-weight-bold"
                          style="color: #00000"
                        >
                          <span v-if="detalle.precio_unidad_real">{{
                            detalle.precio_unidad_real
                          }}</span>
                        </td>
                        <td
                          v-if="!detalle.precio_unidad_real"
                          class="text-right font-weight-bold"
                          style="color: #00000"
                        ></td>
                        <td
                          class="text-right font-weight-bold"
                          style="color: #00000"
                          v-bind:class="{
                            'bg-warning':
                              detalle.diferencia_precio > 0 ||
                              detalle.diferencia_precio < 0,
                          }"
                        >
                          {{ detalle.diferencia_precio }}
                        </td>
                        <td class="text-right font-weight-bold">
                          <span v-if="detalle.precio_real"
                            >Q {{ detalle.precio_real }}</span
                          >
                        </td>
                        <td class="text-center font-weight-bold">
                          <div class="value text-success" v-if="detalle.estado == 'A'">
                            {{ detalle.estado_str }}
                          </div>
                          <div class="value text-info" v-if="detalle.estado == 'B'">
                            {{ detalle.estado_str }}
                          </div>
                          <div class="value text-secondary" v-if="detalle.estado == 'P'">
                            {{ detalle.estado_str }}
                          </div>
                          <div class="value text-danger" v-if="detalle.estado == 'N'">
                            {{ detalle.estado_str }}
                          </div>
                          <div class="value text-info" v-if="detalle.estado == 'S'">
                            {{ detalle.estado_str }}
                          </div>
                          <div class="value text-danger" v-if="detalle.estado == 'X'">
                            {{ detalle.estado_str }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="2">Total de conteo</td>
                        <td
                          v-if="current && current.total_precio_real"
                          class="text-right"
                          colspan="5"
                        >
                          Q {{ current.total_precio_real.toFixed(2) }}
                        </td>
                        <td colspan="4"></td>
                      </tr>
                    </tfoot>
                  </table>
                  <!-------------------- END - Basic Table -------------------->
                </div>
              </div>
              <div class="form-buttons-w">
                <button
                  class="btn btn-md btn-success"
                  v-if="current.id == null"
                  type="submit"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="onboardingSlideModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-centered" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" @click="hideModal" type="button">
            <span class="close-label">Cerrar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-slider-w">
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <h4 class="onboarding-title">Opciones</h4>
                <button
                  type="button"
                  v-if="current && current.estado == 'C'"
                  class="btn btn-block btn-md btn-dark"
                  @click="abrirModalCorregirCantidades(detalle_actual)"
                >
                  Corregir Factura
                </button>
                <button
                  type="button"
                  v-if="current && current.estado == 'A'"
                  @click="eliminarLinea(detalle_actual)"
                  class="btn btn-block btn-sm btn-danger"
                >
                  Eliminar Linea
                </button>
                <br
                  v-if="detalle_actual.estado_str == 'No Solicitado en Orden de Compra'"
                />
                <button
                  v-if="
                    detalle_actual.estado_str == 'No Solicitado en Orden de Compra' &&
                    current &&
                    current.estado == 'A'
                  "
                  type="button"
                  @click="solicitarAutorizacion"
                  class="btn btn-block btn-sm btn-info"
                >
                  Solicitar Autorizacion
                </button>
                <br />
                <button
                  v-if="current && current.estado == 'A'"
                  type="button"
                  class="btn btn-block btn-sm btn-warning"
                >
                  Rechazar
                </button>
              </div>
            </div>
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <h4 class="onboarding-title" v-if="detalle_actual">
                  {{ detalle_actual.producto_obj.sku }}
                </h4>
                <div class="onboarding-text" v-if="detalle_actual">
                  {{ detalle_actual.producto_obj.nombre }}
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <table
                      class="table table-lightborder table-bordered table-v-compact mb-0"
                      v-if="detalle_actual"
                    >
                      <tbody>
                        <tr>
                          <td>
                            <div class="balance-label smaller lighter text-nowrap">
                              Precio OC
                            </div>
                            <strong>{{ detalle_actual.precio_oc }}</strong>
                          </td>
                          <td
                            class="d-sm-none d-xxxxl-table-cell d-md-table-cell d-xxl-none"
                          >
                            <div class="balance-label smaller lighter text-nowrap">
                              Precio Unidad
                            </div>
                            <strong>{{ detalle_actual.precio_unidad }}</strong>
                          </td>
                          <td>
                            <div class="balance-label smaller lighter text-nowrap">
                              Precio Linea
                            </div>
                            <strong>{{ detalle_actual.precio }}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="balance-label smaller lighter text-nowrap">
                              Pedida
                            </div>
                            <strong>
                              <span v-if="detalle_actual.orden_compra_d">{{
                                detalle_actual.orden_compra_d.cantidad
                              }}</span>
                              <span v-if="!detalle_actual.orden_compra_d">0</span>
                            </strong>
                          </td>
                          <td>
                            <div class="balance-label smaller lighter text-nowrap">
                              Lote
                            </div>
                            <strong>
                              <span v-if="detalle_actual.producto_lote">{{
                                detalle_actual.producto_lote.codigo_lote
                              }}</span>
                              <span v-if="!detalle_actual.producto_lote">UNICO</span>
                            </strong>
                          </td>
                          <td
                            class="d-sm-none d-xxxxl-table-cell d-md-table-cell d-xxl-none"
                          >
                            <div class="balance-label smaller lighter text-nowrap">
                              Estado
                            </div>
                            <strong>{{ detalle_actual.estado_str }}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <div class="balance-label smaller lighter text-nowrap">
                              Orden de Compra
                            </div>
                            <strong>
                              <span v-if="detalle_actual.orden_compra_d">{{
                                detalle_actual.orden_compra_d.codigo_lote
                              }}</span>
                              <span v-if="!detalle_actual.orden_compra_d"
                                >No Tiene Orden de Compra</span
                              >
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <div class="balance-label smaller lighter text-nowrap">
                              Tarima
                            </div>
                            <strong>
                              <span>{{ detalle_actual.tarima }}</span>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <div class="balance-label smaller lighter text-nowrap">
                              Cantidad
                            </div>
                            <h1>
                              <strong>
                                {{ detalle_actual.cantidad }}
                              </strong>
                            </h1>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="corregirModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" @click="hideModal" type="button">
            <span class="close-label">Cerrar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-slider-w">
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <h4 class="onboarding-title"></h4>
                <div class="row">
                  <div class="col-3">
                    <label>Recibida</label>
                    <input
                      v-model="currentDetalle.recibida"
                      class="form-control text-right"
                      type="text"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-3">
                    <label>Inconsistencia</label>
                    <input
                      v-model="currentDetalle.inconsistencia"
                      class="form-control text-right"
                      type="text"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-3">
                    <label>Ingresada real</label>
                    <input
                      v-model="currentDetalle.cantidad"
                      class="form-control text-right"
                      type="text"
                    />
                    <br />
                  </div>
                  <div class="col-3">
                    <label>Precio de Linea</label>
                    <input
                      v-model="currentDetalle.precio_real"
                      class="form-control text-right"
                      type="text"
                    />
                    <br />
                  </div>
                  <div class="col-12">
                    <ProductoSelectComponentV2 :current="currentDetalle" />
                  </div>
                </div>
                <div>
                  <button
                    title="Para calcular la cantidad recibida y la inconsitencia 
debe presionar recalcular antes de guardar la información"
                    @click="recalcular"
                    type="button"
                    class="btn btn-md btn-success col-5"
                  >
                    Recalcular cantidad
                  </button>
                  &nbsp;
                  <button
                    title="Para guardar la información de la 
factura despues de recalcular 
presione guardar información"
                    @click="guardarCorrecion()"
                    class="btn btn-md btn-success col-5"
                    type="button"
                  >
                    Guardar Información
                  </button>
                </div>
                <hr />
                <div>
                  <button
                    title="Esta accion anulara la devolucion de la factura y 
autoriza la linea sin orden de compra para 
que se toma en cuenta dentro del inventario"
                    @click="anularDevolucion()"
                    type="button"
                    class="btn btn-blue col-10 btn-md"
                  >
                    Anular Devolución
                  </button>
                  &nbsp;
                </div>
                <br />
                <div
                  style="
                    border-left: 6px solid #0087ff !important;
                    color: #000 !important;
                    background-color: #ddffff !important;
                  "
                  class="alert alert-light text-justify"
                  role="alert"
                >
                  <h6 class="alert-heading text-center text-info">Observaciones</h6>
                  <p class="font-weight-bold"></p>
                  <span class="fas fa-info text-info"></span>
                  <small class="text-dark font-weight-bold">
                    Al presionar el botón guardar usted estara cambiando la información de
                    la factura &nbsp;
                    <span class="font-weight-bold" style="color: blue"
                      ># {{ current.documento }}</span
                    >
                    y la entrada por compra de esta factura, bajo su responsabilidad!
                  </small>
                  <p class="mb-0"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalCambiarProveedor"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Modificar datos de la recepción
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <ProveedoresSelectComponent :current="current" />
              </div>
              <div class="col-12">
                <TiendaSelectComponent :desblock="true" :current="current" />
              </div>
            </div>
            <div
              style="
                border-left: 6px solid rgb(0, 26, 255) !important;
                background-color: #6e84ce !important;
              "
              class="alert alert-light text-justify"
              role="alert"
            >
              <span class="fas fa-info text-info"></span>
              <small class="text-white font-weight-bold">
                Los datos modificados aquí afectarán toda la recepción y las demás
                facturas dentro de ella.
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-7">
              <button
                class="btn btn-danger btn-md"
                type="button"
                @click="duplicarAnularRecepcion()"
              >
                <i class="fas fa-clone"></i>
                Duplicar y Anular Recepción
              </button>
            </div>
            <div class="col-5">
              <button @click="ModificarRecepcion()" type="button" class="btn btn-primary">
                <i class="fas fa-save"></i> Guardar cambios
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalModificarDatosFactura"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalModificarDatosFactura"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalModificarDatosFactura">
              Cambiar datos de factura
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-6">
                <label># Documento</label>
                <input type="text" class="form-control" v-model="current.documento" />
              </div>
              <div class="col-6">
                <label># Serie</label>
                <input type="text" class="form-control" v-model="current.serie" />
              </div>
              <div class="col-6">
                <label>Total Documento</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="current.total_documento"
                />
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.fecha_documento,
                    }"
                    >Fecha Documento</label
                  >
                  <input
                    type="date"
                    class="form-control"
                    v-model="current.fecha_documento"
                  />
                  <small
                    v-if="current.errors && current.errors.fecha_documento"
                    class="form-text text-danger"
                    >{{ current.errors.fecha_documento[0] }}</small
                  >
                </div>
              </div>

              <br />
              <div
                style="
                  border-left: 6px solid #0087ff !important;
                  color: #000 !important;
                  background-color: #ddffff !important;
                "
                class="alert alert-light text-justify col-12"
                role="alert"
              >
                <h6 class="alert-heading text-center text-info">Observaciones</h6>
                <span class="fas fa-info text-info"></span>
                <small class="text-dark font-weight-bold">
                  Los cambios efectuados seran bajo su propia responsabilidad.
                </small>
                <p class="mb-0"></p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-6">
              <button
                type="button"
                @click="anularFactura()"
                class="btn btn-danger btn-block"
              >
                <i class="fas fa-file-excel"></i> Anular factura
              </button>
            </div>
            <div class="col-6">
              <button
                @click="CorregirFactura()"
                type="button"
                class="btn btn-primary btn-block"
              >
                <i class="fas fa-save"></i> Guardar cambios
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="current.recepcion">
      <LogModalComponent modulo="wms" transac="recepcion" :id="current.recepcion" />
    </div>
  </div>
</template>
<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import LogModalComponent from "@/components/commons/LogModalComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    ProductoSelectComponentV2,
    ProveedoresSelectComponent,
    LogModalComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      current_recepcion: {
        tienda_obj: "",
      },
      current: {
        recepcion: "",
        tienda: "",
        err: "",
        archivo: "xxx",
      },
      currentDetalle: {
        producto: "",
        err: "",
      },
      detalle_actual: "",
      producto_tienda: "",
      err: "",
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent(this.$route.params.id);
    }
  },
  methods: {
    mostrarArchivoAdjunto() {
      if (this.current.archivo == null) {
        Notifications.alert.error("Todavia no se ha subido la factura escaneada", "");
        return;
      }
      window.open(this.current.archivo, "_blank");
    },
    anularFactura() {
      let self = this;
      Notifications.alert.confirm(
        "¿Esta seguro de anular factura?",
        "Si realiza esta acción no podra regresar a un estado anterior",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "facturas",
            self.current.id,
            "anular_factura"
          ).then((response) => {
            self.refreshCurrent(self.$route.params.id);
            $("#modalModificarDatosFactura").modal("hide");
            Notifications.alert
              .success("Anular factura", "Realizado correctamente")
              .catch((error) => {
                Notifications.alert.error("Anular factura", error.response.data.detail);
              });
          });
        }
      );
    },
    imprimir() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/recepcion/diferenciapreciofactura/diferenciapreciofactura.jrxml&factura_e_id=${self.id}`
      );
    },
    duplicarAnularRecepcion() {
      let self = this;
      Notifications.alert.confirm(
        "Duplicar y Anular Recepción",
        "Si usted utiliza esta función se anulará y se duplicará la información de la recepción que generó esta factura y las otras facturas de la misma recepción.",
        "Si",
        function () {
          DynamicService.postAction(
            "wms",
            "recepcion",
            self.current.recepcion,
            "anular_duplicar_recepcion"
          )
            .then((response) => {
              let id = response.data;

              $("#modalCambiarProveedor").modal("show");
              Notifications.alert.success(
                "Duplicar y Anular Recepción",
                "Realizado Exitosamente",
                ""
              );
              self.$router.push({
                name: "wms-recepcion-editar",
                params: { id: id },
              });
              self.refreshCurrent();
              self.deseleccionar();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Duplicar y Anular Recepción",
                error.response.data.detail
              );
            });
        }
      );
    },
    customFormatterInverted(date) {
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).format("YYYY-MM-DD");
    },
    CorregirFactura() {
      DynamicService.postAction(
        "wms",
        "facturas",
        this.current.id,
        "modificar_factura",
        this.current
      )
        .then((response) => {
          Notifications.alert.success(
            "Modificar datos de la factura",
            "Realizado Correctamente"
          );
          this.refreshCurrent(this.current.id);
          $("#modalModificarDatosFactura").modal("hide");
        })
        .then((errors) => {
          Notifications.alert.error(
            "Cambiar proveedor de recepeción",
            errors.response.data.detail
          );
        });
    },
    abrirModalModificarFactura() {
      $("#modalModificarDatosFactura").modal("show");
    },
    abrirModalLogRecepciones() {
      $("#modalLog").modal("show");
    },
    abrirModalCorregirProveedor() {
      $("#modalCambiarProveedor").modal("show");
    },
    ModificarRecepcion() {
      DynamicService.postAction(
        "wms",
        "facturas",
        this.current.id,
        "modificar_recepcion",
        {
          codigo_tienda: this.current.tienda,
          codigo_proveedor: this.current.proveedor.codigo,
        }
      )
        .then((response) => {
          Notifications.alert.success("Corregir recepción", "Realizado Correctamente");
          this.refreshCurrent(this.current.id);
          $("#modalCambiarProveedor").modal("hide");
        })
        .catch((errors) => {
          Notifications.alert.error("Corregir recepción", errors.response.data.detail);
        });
    },
    generarCXP() {
      let self = this;
      Notifications.alert.confirm(
        "Generar cargo de cuentas por pagar",
        "si ya cuadro la factura y esta seguro de continuar precione OK",
        "",
        function () {
          DynamicService.getActionList("wms", "recepcion", "generar_cargo_cxp", {
            id: self.current.entrada_por_compra_e,
          })
            .then((reponse) => {
              Notifications.alert.success(
                "Generar cargo de cuentas por pagar",
                "Realizado correctamente"
              );
              self.$router.push({
                name: "cxp-cargo-editar",
                params: { id: reponse.data.id },
              });
            })
            .catch((errors) => {
              console.log(errors.response.data.detail);
              Notifications.alert.error(
                "Generar cargo de cuentas por pagar",
                errors.response.data.detail
              );
            });
        }
      );
    },
    RevisarFactura() {
      let self = this;
      DynamicService.postAction("wms", "facturas", self.current.id, "revisar_factura")
        .then((response) => {
          Notifications.alert.success("Factura", "Revisado Correctamente");
          self.refreshCurrent(self.current.id);
        })
        .catch((err) => {
          Notifications.alert.error("Corregir Factura", err.response.data.detail);
        });
    },
    verDetalleLinea(linea) {
      let self = this;
      if (this.current.estado == "9") {
        alert("Factura se encuentra anulada");
        return;
      }
      self.detalle_actual = linea;
      self.showModal();
    },
    anularDevolucion() {
      let self = this;
      Notifications.alert.confirm(
        "¡IMPORTANTE!",
        "Aqui se anulara la devolución de la linea seleccionada tanto si es por no solicitado o porque si fue mal estado",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "facturas",
            self.current.id,
            "anular_devolucion_y_autorizar",
            {
              id: self.currentDetalle.id,
            }
          )
            .then((response) => {
              Notifications.alert.success("Autorizar Linea", "Realizado Correctamente");
              self.refreshCurrent(self.current.id);
              self.hideModal();
            })
            .catch((error) => {
              Notifications.alert.error("Autorizar Linea", error.response.data.detail);
            });
        }
      );
    },
    hideModal() {
      $("#onboardingSlideModal").modal("hide");
      $("#corregirModal").modal("hide");
    },
    recalcular() {
      let self = this;
      let producto = null;
      if (self.currentDetalle.producto) {
        producto = self.currentDetalle.producto;
        self.currentDetalle.producto = self.currentDetalle.producto.sku;
      }
      DynamicService.postAction(
        "wms",
        "facturas",
        self.current.id,
        "recalcular_cantidad",
        self.currentDetalle
      )
        .then((response) => {
          self.currentDetalle = response.data;
          self.currentDetalle.producto = producto;
        })
        .catch((err) => {
          console.log(err);
          Notifications.alert.error("Corregir Factura", err.response.data.detail);
        });
    },
    showModal() {
      let self = this;
      let params = {
        producto: self.detalle_actual.producto,
        tienda: self.current.tienda,
        quitar_paginacion: true,
      };
      DynamicService.fetch("cat", "producto-tienda", params).then((res) => {
        self.producto_tienda = res.data;
      });
      $("#onboardingSlideModal").modal("show");

      $("#onboardingSlideModal.show-on-load").modal("show");
      if ($("#onboardingSlideModal .onboarding-slider-w").length) {
        $("#onboardingSlideModal .onboarding-slider-w").slick({
          dots: true,
          infinite: false,
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow:
            '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style="">Regresar</button>',
          nextArrow:
            '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false">Más Información</button>',
        });
        $("#onboardingSlideModal").on("shown.bs.modal", function (e) {
          $("#onboardingSlideModal .onboarding-slider-w").slick("setPosition");
        });
        $("#onboardingSlideModal").on("hide.bs.modal", function (e) {
          $("#onboardingSlideModal .onboarding-slider-w").slick("unslick");
        });
      }
    },
    guardarCorrecion() {
      let self = this;
      if (self.currentDetalle.producto) {
        self.currentDetalle.producto = self.currentDetalle.producto.sku;
      }
      DynamicService.postAction(
        "wms",
        "facturas",
        self.current.id,
        "corregir_cantidad",
        self.currentDetalle
      )
        .then((response) => {
          self.currentDetalle = response.data;
          Notifications.alert.success("Corregir Factura", "Fue generado Correctamente. ");
          $("#corregirModal").modal("hide");
          self.refreshCurrent(self.current.id);
        })
        .catch((err) => {
          console.log(err.response);
          if (err.response) {
            Notifications.alert.error("Corregir Factura", err.response.data.detail);
          }
        });
    },
    abrirModalCorregirCantidades(detalle) {
      let self = this;
      self.currentDetalle = detalle;
      self.currentDetalle.producto = detalle.producto_obj;
      $("#corregirModal").modal("show");
      $("#onboardingSlideModal").modal("hide");
    },
    refreshusuario() {
      let self = this;
      DynamicService.getById("accounts", "usuarios", this.current.usuario).then(
        (response) => {
          this.current.usuario = response.data;
        }
      );
    },
    refreshProveedor() {
      let self = this;
      DynamicService.getById("cat", "proveedores", this.current.proveedor).then(
        (response) => {
          this.current.proveedor = response.data;
        }
      );
    },
    refresh_info_recepcion() {
      let self = this;
      DynamicService.getById("wms", "recepcion", self.current.recepcion).then(
        (response) => {
          self.current_recepcion = response.data;
        }
      );
    },
    refreshCurrent(params) {
      let self = this;
      DynamicService.getById("wms", "facturas", params).then((response) => {
        self.current = response.data;
        if (self.current.proveedor) {
          self.refreshProveedor();
        }
        self.current.fecha_documento = self.customFormatterInverted(
          self.current.fecha_documento
        );
        if (self.current.usuario) {
          self.refreshusuario();
        }
        self.refresh_info_recepcion();
      });
    },
  },
};
</script>
